import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_PREFIX as API, API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';

export const CUSTOMERS_ACTION_TYPES = {
	GET_CUSTOMERS_SUCCESS: 'GET_CUSTOMERS_SUCCESS',
    POST_CUSTOMER_SUCCESS: 'POST_CUSTOMER_SUCCESS',
    PUT_CUSTOMER_SUCCESS: 'PUT_CUSTOMER_SUCCESS',
    DELETE_CUSTOMER_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_CUSTOMERS_PAGINATION: 'UPDATE_CUSTOMERS_PAGINATION'
};

const CUSTOMERS_URL = `${ENTRYPOINT}${API_ROUTES.CUSTOMERS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        let searchParams = `&search=${search}`;
        if (search.split(' ').length === 2) {
            const [firstName, lastName] = search.split(' ');
            searchParams = `&firstName=${firstName}&lastName=${lastName}`;
        }
        filterParams = `${filterParams}${searchParams}`;
    }
    return filterParams;
}

const formatData = (data) => {
    if (data.worker) {
        data.worker = `${API}${API_ROUTES.WORKERS}/${data.worker.uuid}`;
    }
    return data;
}

export const getCustomers = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(formatData(data));
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_CUSTOMERS_URL = `${CUSTOMERS_URL}${params}`;
        const response = await getData(GET_CUSTOMERS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: CUSTOMERS_ACTION_TYPES.GET_CUSTOMERS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: CUSTOMERS_ACTION_TYPES.UPDATE_CUSTOMERS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getCustomer = async (uuid) => {
    const GET_CUSTOMER_URL = `${CUSTOMERS_URL}/${uuid}`;
    return await getData(GET_CUSTOMER_URL, getHeaders());
}

export const postCustomer = (data) => (
    async (dispatch) => {
        const response = await postData(CUSTOMERS_URL, formatData(data), getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: CUSTOMERS_ACTION_TYPES.POST_CUSTOMER_SUCCESS, payload: response });
        return response;
    }
)

export const putCustomer = (uuid, data) => (
    async (dispatch) => {
        const PUT_CUSTOMERS_URL = `${CUSTOMERS_URL}/${uuid}`;
        const response = await putData(PUT_CUSTOMERS_URL, formatData(data));
        dispatch({ type: CUSTOMERS_ACTION_TYPES.PUT_CUSTOMER_SUCCESS, payload: response });
        return response;
    }
)

export const deleteCustomer = (uuid) => (
    async () => {
        const DELETE_CUSTOMERS_URL = `${CUSTOMERS_URL}/${uuid}`;
        await deleteData(DELETE_CUSTOMERS_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateCustomersPagination = ({ rowsPerPage, page = 0, filters }) =>
    (dispatch) => {
        dispatch({ type: CUSTOMERS_ACTION_TYPES.UPDATE_CUSTOMERS_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getCustomers({ page, rowsPerPage, filters }));
    }

